<template>
  <div class="applyAccount-record">
    <div class="card-base card-shadow--small pr-30 pl-30 h-457" v-if="threeListData.length > 0">
      <h2 class="account-info-title">{{$t('applyTradeAccount.applyRecords')}}</h2>
      <el-card v-for="(item,index) in threeListData" :key="index" class="apply-records-list" :class="item.status">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
            <span class="apply-order">{{$t('applyTradeAccount.orderId')+item.orderId}}</span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="text-right hidden-md-and-down">
            <small>
              {{moment(item.createdDate).format('YYYY-MM-DD')}}
              <!-- {{item.updatedTime | date-str('YYYY-MM-DD')}} -->
              <br>
              {{moment(item.createdDate).format('HH:mm:ss')}}
              <!-- {{item.updatedTime | date-str('HH:mm:ss')}} -->
            </small>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="text-right hidden-md-and-up">
            <small>
              {{moment(item.createdDate).format('YYYY-MM-DD')}}
              <br>
              {{moment(item.createdDate).format('HH:mm:ss')}}
            </small>
          </el-col>
        </el-row>
        <el-row class="bt-1 p-8">
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="text-left ">{{$t('applyTradeAccount.accountType')}}</el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="text-right">{{translateTradeAccountType(item.accountType)}}</el-col>
        </el-row>
        <el-row class="bt-1 p-8">
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="text-left">{{$t('applyTradeAccount.status')}}</el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="text-right">{{applyAccountStatus(item.status)}}</el-col>
        </el-row>
        <el-row class="bt-1 p-8" v-if="item.status==='REJECT'">
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="text-left">{{$t('applyTradeAccount.refuseReason')}}</el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="text-right">{{item.remark }}</el-col>
        </el-row>
      </el-card>

    </div>
    <div v-else class="card-base card-shadow--small pr-30 pl-30  h-457">
      <h2 class="account-info-title">{{$t('applyTradeAccount.applyRecords')}}</h2>
      <div class="noapply-records-list">
        <div>{{$t('applyTradeAccount.noRecords')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  data () {
    return {
      moment
    }
  },
  props: {
    threeListData: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    translate (type) {
      return this.$t('applyTradeAccount.' + type.toLowerCase())
    },
    translateTradeAccountType (tradeAccountType) {
      return this.$t('tradeAccountType.' + tradeAccountType)
    },
    applyAccountStatus (status) {
      switch (status) {
        case 'SUCCESS':
          return this.$t('applyTradeAccount.success')
        case 'PASS':
          return this.$t('applyTradeAccount.pass')
        case 'CHECKING':
          return this.$t('applyTradeAccount.checking')
        case 'SUBMITTED':
          return this.$t('applyTradeAccount.submitted')
        case 'REJECT':
          return this.$t('applyTradeAccount.reject')
        case 'RESET':
          return this.$t('common.reactivate')
        default:
          break
      }
    }
  }

}
</script>
<style lang="scss" scoped>
.applyAccount-record {
  .apply-records-list {
    margin-bottom: 20px;

    .apply-order {
      color: rgba(36, 40, 45, 1);
      font-size: 16px;
      text-align: left;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      line-height: 40px;
    }

    .other-account-type {
      height: 16px;
      color: rgba(125, 125, 125, 1);
      font-size: 12px;
      text-align: left;
      font-family: PingFangSC-Regular;
    }

    .text-left {
      text-align: left;
      color: rgba(125, 125, 125, 1);
      font-size: 12px;
      font-family: PingFangSC-Regular;
    }

    .text-right {
      color: rgba(36, 40, 45, 1);
      font-size: 12px;
      text-align: right;
      font-family: PingFangSC-Semibold;
    }
  }

  .SUCCESS {
    border-bottom: 4px solid #7bcc5b;
  }

  .CHECKING,
  .PASS,
  .SUBMITTED {
    border-bottom: 4px solid #7d7d7d;
  }

  .REJECT {
    border-bottom: 4px solid #e02a2a;
  }
}
</style>
